import {
  getJson,
  putJson,
  postJson,
  deleteJson,
} from '../../http/cloud-backend-infrastructure';
import { getJson as getUserApiJson } from '../../http/user-api-infrastructure';
import { encodeUrlTag } from '../../common/utils/url';

export const getValidationJson = () => getJson('/api/v1.0/partner/validations-config');

/** Retrieves the pilot features (including Core_NmbrsLaunch) for the environment's configured partner. */
export const getPilotFeatures = () => getUserApiJson(encodeUrlTag`/api/v2/partner/${pilotFeaturesPartnerId}/pilot-features`);

export const getPartnerDetails = () => getJson('/api/v1.0/partner/partner-view');

export const getPartnerSteps = () => getJson('/api/v1.0/partner/partner-steps');

const getAdministrationSoftwares = () => getJson('/api/v1.0/partner/administration-softwares');

const getPayrollSoftwares = () => getJson('/api/v1.0/partner/payroll-softwares');

const getTaxationSoftwares = () => getJson('/api/v1.0/partner/taxation-softwares');

const getCountryTypes = () => getJson('/api/v1.0/partner/country-types');

/** As we are only targetting Netherlands for now, commented other countries API call and code */

// const getCountries = () => getJson('/api/v1.0/lookup/countries');

const getSBIOptions = () => getJson('/api/v1.0/sbi-options');

export const getFirmLogo = (partnerId) => getJson(`/api/v1.0/partner/${partnerId}/partner-logo`);

export const getFieldOptions = async () => {
  const [administrationSoftwaresOptions, payrollSoftwaresOptions,
    taxationSoftwaresOptions, countryTypesOptions,
    sbiOptionsList] = await Promise.all([
    getAdministrationSoftwares(),
    getPayrollSoftwares(),
    getTaxationSoftwares(),
    getCountryTypes(),
    getSBIOptions(),
  ]);
  const { administrationSoftwares } = administrationSoftwaresOptions;
  const { payrollSoftwares } = payrollSoftwaresOptions;
  const { taxationSoftwares } = taxationSoftwaresOptions;
  const { countryTypes } = countryTypesOptions;
  const { sbiOptions } = sbiOptionsList;
  return {
    administrationSoftwares,
    payrollSoftwares,
    taxationSoftwares,
    countryTypes,
    sbiOptions,
  };
};

export const saveFirmKeyDetails = (partnerId, data) => putJson(`/api/v1.0/partner/${partnerId}/firm-key-details`, data);

export const saveFirmAddress = (partnerId, data) => putJson(`/api/v1.0/partner/${partnerId}/firm-address`, data);

export const addEmployee = (partnerId, data) => postJson(`/api/v1.0/partner/${partnerId}/employee`, data);

export const deleteEmployee = (partnerId, email) => deleteJson(encodeUrlTag`/api/v1.0/partner/${partnerId}/employee?email=${email}`);

export const saveOtherSoftwares = (partnerId, data) => putJson(`/api/v1.0/partner/${partnerId}/other-softwares-used`, data);

export const saveFirmLogo = (partnerId, data) => putJson(`/api/v1.0/partner/${partnerId}/upload-firm-logo`, data);

export const saveInvoiceInformation = (partnerId, data) => putJson(`/api/v1.0/partner/${partnerId}/invoice-information`, data);

export const saveReviewDetails = (partnerId, isPartnerTermsAccepted, lastModified) => postJson('/api/v1.0/partner/partner-review-and-submit', { partnerId, isPartnerTermsAccepted, lastModified });
